/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SocialDrawerFeature = {
    NOTIFICATIONS: 'NOTIFICATIONS',
    FEED: 'FEED',
    FRIENDS: 'FRIENDS',
    CHAT: 'CHAT',
    CLIPS: 'CLIPS',
    EARN: 'EARN',
    CHALLENGE: 'CHALLENGE',
    CONNECTIONS: 'CONNECTIONS',
    STATS: 'STATS'
} as const;
export type SocialDrawerFeature = typeof SocialDrawerFeature[keyof typeof SocialDrawerFeature];


export function instanceOfSocialDrawerFeature(value: any): boolean {
    for (const key in SocialDrawerFeature) {
        if (Object.prototype.hasOwnProperty.call(SocialDrawerFeature, key)) {
            if (SocialDrawerFeature[key as keyof typeof SocialDrawerFeature] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SocialDrawerFeatureFromJSON(json: any): SocialDrawerFeature {
    return SocialDrawerFeatureFromJSONTyped(json, false);
}

export function SocialDrawerFeatureFromJSONTyped(json: any, ignoreDiscriminator: boolean): SocialDrawerFeature {
    return json as SocialDrawerFeature;
}

export function SocialDrawerFeatureToJSON(value?: SocialDrawerFeature | null): any {
    return value as any;
}

export function SocialDrawerFeatureToJSONTyped(value: any, ignoreDiscriminator: boolean): SocialDrawerFeature {
    return value as SocialDrawerFeature;
}

